export class GlobalTimeOut{
    dashboardTimeOut : 120000
}